import { useFormControlProps } from '@chakra-ui/react';
import { omitThemingProps } from '@chakra-ui/system';

import { Input, type InputProps } from '@frontend/components';

import { COUNTRY_SELECTOR_WIDTH } from './PhoneInputCountrySelect';
import { usePhoneInputContext } from './usePhoneInputContext';

export type PhoneInputFieldProps = InputProps;

export const PhoneInputField = ({ onChange, ...restProps }: InputProps) => {
  const { inputRef, inputValue, handlePhoneValueChange, stateProps } =
    usePhoneInputContext();

  const ownProps = omitThemingProps({ ...stateProps, ...restProps });
  const controlProps = useFormControlProps(ownProps);

  return (
    <Input
      placeholder="Phone number"
      type="tel"
      value={inputValue}
      onChange={(event) => {
        handlePhoneValueChange(event);
        onChange?.(event);
      }}
      paddingLeft={COUNTRY_SELECTOR_WIDTH + 1}
      {...controlProps}
      {...restProps}
      ref={inputRef}
    />
  );
};
